import { useCallback, useState } from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import { useAvatarChangeBlockTOHMutation } from "../../core/api/toh-user-api"

const TohAvatarChangeBlockControl = ({ disabled, userId }) => {
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [block, { isLoading }] = useAvatarChangeBlockTOHMutation()

    const handleOpenConfirm = useCallback(() => {
        setConfirmOpen(true)
    }, [])

    const handleCloseConfirm = useCallback(() => {
        setConfirmOpen(false)
    }, [])

    const handleConfirm = useCallback(async () => {
        await block({ userId, blocked: true })
        setConfirmOpen(false)
    }, [block, userId])

    return (
        <>
            <Button
                fullWidth
                size="small"
                color="error"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenConfirm}
            >
                Block
            </Button>
            <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
                <DialogTitle>Block avatar change for '{userId}'?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Cancel</Button>
                    <Button variant="contained" loading={isLoading} onClick={handleConfirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohAvatarChangeBlockControl
